import { useEffect, useState } from "react";

const coincide = (query: string) =>
  typeof window !== "undefined" && typeof window.matchMedia === "function"
    ? window.matchMedia(query).matches
    : false;

/** Indica si la media query coincide y se actualiza al cambiar el tamaño. */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => coincide(query));

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}
